import Skeleton from "../../Common/Skeleton";

const SumSubKYCSheckSkeleton = () => {
  return (
    <div className="w-full md:w-[800px] lg:w-[900px] mx-auto p-6 md:p-8 bg-background-surface border border-divider rounded-3xl shadow-sm custom-transition">
      <div className="flex flex-col items-center justify-center space-y-4 w-full">
        {/* Skeleton Title */}
        <Skeleton className="w-64 h-8 rounded-full" />
        {/* Skeleton Subtitle */}
        <Skeleton className="w-80 h-4 rounded-full mb-6" />

        {/* Skeleton Iframe Container */}
        <Skeleton className="w-full h-[500px] md:h-[600px] rounded-2xl mt-6" />
      </div>
    </div>
  );
};
export default SumSubKYCSheckSkeleton;
